<template>
  <v-layout style="background-color:#efefef">
    <v-spacer />
    <DateBar
      :display-start-date="displayStartDate"
      :display-end-date="displayEndDate"
      :start-date="item.summary.startTime"
      :end-date="item.summary.endTime"
    >
      <template v-if="canShowDateStr && !isBarTooNarrow">
        <span style="z-index:5; position:absolute; bottom:0; left: 0">
          {{ startDateStr }}
        </span>
        <span style="z-index:5; position:absolute; bottom:0; right: 0">
          {{ endDateStr }}
        </span>
      </template>
      <DateRangeInsertionOrder
        :bg-color="bgColorOfBar"
        :can-clip="!isBarTooNarrow"
        :tooltip-text="startDateStr + ' 〜 ' + endDateStr"
      />
    </DateBar>
  </v-layout>
</template>

<script>
import dayjs from 'dayjs'
import DateBar from './CampaignModalPageBudgetListDateBar'
import DateRangeInsertionOrder from './CampaignModalPageBudgetListDateRangeInsertionOrder'

export default {
  components: {
    DateBar,
    DateRangeInsertionOrder,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      default: 0,
    },
    displayStartDate: {
      type: String,
      default: '',
    },
    displayEndDate: {
      type: String,
      default: '',
    },
  },
  computed: {
    isBarTooNarrow() {
      // 視認しにくいレベル（とりあえず8%）まで狭かったら色々表示しない
      return (
        dayjs(this.item.summary.endTime).diff(this.item.summary.startTime) /
          dayjs(this.displayEndDate).diff(this.displayStartDate) <
        0.08
      )
    },
    canShowDateStr() {
      return !(
        dayjs(this.item.summary.startTime).isAfter(this.displayEndDate) ||
        dayjs(this.item.summary.endTime).isBefore(this.displayStartDate)
      )
    },
    startDateStr() {
      const startTime = dayjs(this.displayStartDate).isAfter(
        this.item.summary.startTime,
      )
        ? this.displayStartDate
        : this.item.summary.startTime
      return dayjs(startTime).format('MM/DD')
    },
    endDateStr() {
      const endTime = dayjs(this.displayEndDate).isBefore(
        this.item.summary.endTime,
      )
        ? this.displayEndDate
        : this.item.summary.endTime
      return dayjs(endTime).format('MM/DD')
    },
    bgColorOfBar() {
      switch (this.item.requestStatus) {
        case 'rejected':
          return 'grey'
        case 'waiting':
          return '#FFE0B2'
        default:
          return '#ede2af'
      }
    },
  },
}
</script>
<style scoped></style>
